/**
 * The three blocks that are ordinary HTML wearing a class.
 *
 * A lede is a paragraph, a checklist is a bullet list, and a numbered section
 * heading is an `<h2>`. Making them separate node types would fork every
 * command that already works on a paragraph or a list - Enter, Backspace, the
 * list keymap, the toolbar's own bold - and buy nothing back. They are the base
 * node plus one attribute instead, so the editor keeps its whole keyboard and
 * the class survives the trip through the document model.
 *
 * The heading's `id` is not decoration. `kbHeadings()` on the server reads
 * `<h2 id>` to build the article's contents rail, so a heading that loses its id
 * on the first save quietly empties that rail - the article still reads fine,
 * and the navigation beside it goes blank.
 */
import BulletList from "@tiptap/extension-bullet-list";
import Heading from "@tiptap/extension-heading";
import Paragraph from "@tiptap/extension-paragraph";

/** `<p class="kb-lede">`: the opening sentence, one per article. */
export const KbLede = Paragraph.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      lede: {
        default: false,
        parseHTML: (el) => el.classList.contains("kb-lede"),
        renderHTML: (attrs) => (attrs.lede ? { class: "kb-lede" } : {}),
      },
    };
  },
});

/** `<ul class="kb-check">`: ticks instead of bullets, for lines to be walked. */
export const KbCheckList = BulletList.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      check: {
        default: false,
        parseHTML: (el) => el.classList.contains("kb-check"),
        renderHTML: (attrs) => (attrs.check ? { class: "kb-check" } : {}),
      },
    };
  },
});

/** `<h2 id="...">`: the id the contents rail is built from. */
export const KbHeading = Heading.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      id: {
        default: null,
        parseHTML: (el) => el.getAttribute("id"),
        renderHTML: (attrs) => (attrs.id ? { id: String(attrs.id) } : {}),
      },
    };
  },
});
